import { render, staticRenderFns } from "./totalinvoice.vue?vue&type=template&id=12fb8c1f&scoped=true&"
import script from "./totalinvoice.vue?vue&type=script&lang=js&"
export * from "./totalinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb8c1f",
  null
  
)

export default component.exports